// Client-side preview of the call script (STSMPD-1322).
//
// The authoritative script is built server-side by the fulfilment-call-service (which also
// derives the notice band from start_time). This preview mirrors the v1 "late-notice fill
// check" opening so Ops can see what the bot will say before placing the call.

import moment from 'moment'

import { AgencyCallModalData } from './AgencyCallModal.types'

const DISCLOSURE = 'This call is from Indeed Flex and may be recorded for quality and training purposes.'

/** "1 hour" / "2 hours" — keeps the spoken preview grammatical. */
const pluralise = (count: number, unit: string): string => `${count} ${unit}${count === 1 ? '' : 's'}`

const noticePhrase = (startTime?: string): string => {
  if (!startTime) return 'coming up soon'
  const start = moment(startTime)
  // An unparseable start_time must not leak "NaN minutes/hours/days" into the script the bot reads.
  if (!start.isValid()) return 'coming up soon'
  const hours = start.diff(moment(), 'hours', true)
  if (hours < 0) return 'that has already started'
  if (hours < 1) return `starting in about ${pluralise(Math.max(1, Math.round(hours * 60)), 'minute')}`
  if (hours < 36) return `starting in about ${pluralise(Math.round(hours), 'hour')}`
  return `starting in about ${pluralise(Math.round(hours / 24), 'day')}`
}

export const buildScriptPreview = (data: AgencyCallModalData): string => {
  const venue = data.venue_name || 'the venue'
  const role = data.role_title || 'the role'
  const client = data.client_name || 'the client'
  const workers = data.workers_required != null ? String(data.workers_required) : 'some'
  const opening =
    `Hi, this is an automated call from Indeed Flex about job ${data.job_id} at ${venue} ` +
    `for ${client}. It's a ${role} shift ${noticePhrase(data.start_time)}, and we still ` +
    `need ${workers} workers. Are you able to fill it?`
  return `${DISCLOSURE}\n\n${opening}`
}
